import { io } from 'socket.io-client';
import { useStore } from '../store/useStore';
import { User } from '../types';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://localhost:3000';

console.log('Socket URL configured:', SOCKET_URL);

export const socket = io(SOCKET_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  transports: ['websocket', 'polling'], // Try websocket first, fallback to polling
});

socket.on('connect', () => {
  console.log('Connected to server with socket ID:', socket.id);
  useStore.getState().setIsConnected(true);

  const user = useStore.getState().user;
  if (user) {
    console.log('Re-registering user after connect:', user.name);
    socket.emit('register', user);
  }
});

socket.on('connect_error', (error) => {
  console.error('Connection error:', error.message);
});

socket.on('disconnect', (reason) => {
  console.log('Disconnected from server. Reason:', reason);
  useStore.getState().setIsConnected(false);
  useStore.getState().setCurrentPartner(null);
});

socket.on('matched', (partner) => {
  console.log('Matched with partner:', partner.name, 'socketId:', partner.socketId);
  useStore.getState().setCurrentPartner(partner);
});

socket.on('message', (message) => {
  useStore.getState().addMessage(message);
});

socket.on('userDisconnected', (userId) => {
  const currentPartner = useStore.getState().currentPartner;
  if (currentPartner?.socketId === userId) {
    useStore.getState().setCurrentPartner(null);
    useStore.getState().clearChat();
  }
});

socket.on('usersCount', (count) => {
  useStore.getState().setActiveUsersCount(count);
});

export const initializeSocket = (user: User) => {
  if (!socket.connected) {
    socket.connect();
  }
  socket.emit('register', user);
};

export const searchNewPartner = () => {
  const user = useStore.getState().user;
  if (user) {
    useStore.getState().clearChat();
    useStore.getState().setCurrentPartner(null);
    socket.emit('register', user);
  }
};
